var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4505",
    d: "M1 0.5H0.5V1V38V38.5H1H36C38.4853 38.5 40.5 36.4853 40.5 34V5C40.5 2.51472 38.4853 0.5 36 0.5H1Z",
    fill: "#ECEDF2",
    stroke: "#EFF0F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 10050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 174",
    d: "M13 17.783H27.692",
    stroke: "#948B9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1244",
    d: "M24.3552 12.9196H25.463C26.1208 12.9198 26.7516 13.1813 27.2167 13.6466C27.6818 14.1118 27.943 14.7427 27.943 15.4006V24.519C27.943 25.1769 27.6818 25.8078 27.2167 26.273C26.7516 26.7383 26.1208 26.9998 25.463 27H15.4799C14.8224 26.9992 14.1922 26.7375 13.7275 26.2723C13.2629 25.8071 13.002 25.1765 13.002 24.519V15.4006C13.002 14.7431 13.2629 14.1125 13.7275 13.6473C14.1922 13.1821 14.8224 12.9204 15.4799 12.9196H24.3552Z",
    stroke: "#948B9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 175",
    d: "M17.5293 11V14.839",
    stroke: "#948B9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 176",
    d: "M23.415 11V14.839",
    stroke: "#948B9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f65ce1540691bced384b91bcb14a53bd.svg";
export { ForwardRef as ReactComponent };